import services from './../../services/service'; // Service
import validator from './../../services/validator'; // Service
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
let service = new services();
let valid = new validator();

export default {
    name: 'Register',
    data () {
        return {
            user: [],
            states: {},
            cities: {},
            disable_btn: false,
            error_here: {},
            error_count: 0,
            password_error_match:"",
            ref_code: "",
            terms_agree:false,
        }
    },
    components: {
        'second-header': SecondHeader,
        'main-footer': MainFooter
    },
    methods: {
        reset() {
             localStorage.removeItem("cityneeds_user");
            //remove session key here linked to session well @server
        },
        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        getCities(state) {
            service.getCities(this, state).then(function(data) {
                this.cities = data.body;
            })
        },
        reg(){
            this.disable_btn = true;
            this.error_count = 0;
            this.error_here.email = "";
            this.error_here.phone = "";
            var credentials = {
                user_fullname: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email,
                user_address: this.user.address,
                user_state: this.user.state,
                user_city: 1,//this.user.city,
                user_password: this.user.password,
                referral_code: this.user.ref_code || localStorage.getItem("cityneeds_ref")
            }

            let navi = this.$router;
        //    if(credentials.user_fullname != undefined && credentials.user_address != undefined && credentials.user_phone != null &&
        //     credentials.user_email != null && credentials.user_password != null) {
            if(this.user.password != this.user.cpassword){
                this.password_error_match = "Passwords do not match";
                this.disable_btn = false;
            }else{
                if(credentials.user_fullname != undefined && credentials.user_address != undefined && credentials.user_password != null) {
                    if(credentials.user_phone || credentials.user_email) {
                        if(this.terms_agree) {
        
                            //validate
                            if(credentials.user_email){
                                if(!(valid.validateEmail(credentials.user_email))){
                                    this.error_here.email = "Invalid Email";
                                    //this.error_here.phone = "Coming soon";
                                    this.error_count += 1;
                                    this.disable_btn = false;
                                    toastr.error('Email is not valid', 'Warning!');
                                }
                            }
        
                            //phone
                            if(credentials.user_phone){
                                if(!(valid.validatePhoneNumber(credentials.user_phone))){
                                    this.error_count += 1;
                                    this.disable_btn = false;
                                    this.error_here.phone = "Invalid Phone";
                                    toastr.error('Phone Number is not valid', 'Warning!');
                                }
                            }
        
                            if(!(valid.validateName(credentials.user_fullname))){
                                this.error_here.name = "Name is not valid";
                                this.error_count += 1;
                                this.disable_btn = false;
                            }
        
                            if(this.error_count == 0){
                                service.regUser(this, credentials).then(function(data) {
                                    if(data.body.status == 201) {
                                        toastr.success("Registration Successfull", 'Success!');
                                        //navi.push('dashboard');
                                        //log user in
                                        //...rfac....login from server
                                        //now
                                        let logdata = data.body.data;
                                        logdata.forEach(function(element) {
                                            localStorage.setItem("cityneeds_user", element.user_fullname);
                                            localStorage.setItem("cityneeds_token", element.user_session_key); //store session key here linked to session well @server
                                            localStorage.setItem("cityneeds_token_key", element.user_token_key); 
                                        }, this);

                                        // navi.push('/');

                                        //for other shared services
                                        let reg_track = localStorage.getItem("current_page");
                                        if(this.reg_track == ''){ //no one is using //default reg
                                            navi.push('/');
                                        }else{ //a service set this
                                            navi.push(reg_track);
                                        }
                                        
                                        //b4
                                        // if(data.body.user_email){ //logn with email
                                        //     var credentials = {
                                        //         user_email: data.body.user_email,
                                        //         user_password: data.body.user_password
                                        //     }
                                        // }
                                        // else{//login with phone no
                                        //     var credentials = {
                                        //         user_email: "0"+data.body.user_phone, //LEADING ZERO ISSUES
                                        //         user_password: data.body.user_password
                                        //     }
                                        // }
                                        // service.loginUser(this, credentials).then(response => {
                                        //     if(response.body.status == 200) {
                                        //         let data = response.body.data;
                                        //         data.forEach(function(element) {
                                        //             localStorage.setItem("cityneeds_user", element.user_fullname);
                                        //             localStorage.setItem("cityneeds_token", element.user_session_key); //store session key here linked to session well @server
                                        //             localStorage.setItem("cityneeds_token_key", element.user_token_key); 
                                        //         }, this);
                                        //         navi.push('/');
                                        //     }else{
                                        //        // navi.push('/login'); 
                                        //     }
                                        // }).catch((err) => {
                                        //     if(err.status == 404) {
                                        //         toastr.warning("invalid login credentials", 'Warning!'); 
                                        //         this.disable_btn = false;
                                        //     }
                                        //     navi.push('/login');
                                        // })

                                        //../...rfac....login from server
                                    }else if(data.body.status == 409) {
                                        //toastr.warning("This User is already registered", 'Warning!');
                                        toastr.warning(data.body.message, 'Warning!');
                                        this.disable_btn = false;
                                    }
                                }).catch((err) => {
                                    console.log(err)
                                    toastr.warning("Please Re-try Once More", 'Warning!');
                                    this.disable_btn = false;
                                })
                            }
                            
                        }else {
                            toastr.error('Please agree to Terms', 'Warning!');
                            this.disable_btn = false;
                        }
                    }else {
                        toastr.error('Requires Phone Number Or Email', 'Warning!');
                        this.disable_btn = false;
                    }
                }else {
                    toastr.error('Kindly fill all fields marked *', 'Warning!');
                    this.disable_btn = false;
                }
            }
        
        }
    },
    created: function(){
        this.reset();
        if((localStorage.getItem("cityneeds_ref") != 'undefined') && (localStorage.getItem("cityneeds_ref") != undefined)){
            this.ref_code = localStorage.getItem("cityneeds_ref");
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Register/script.js